import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Seg } from '@/components/ui/seg';
import { TIME_FILTER_OPTIONS, type PointsTimeFilter } from '@/lib/timeFilter';

export type OwnershipFilter = 'all' | 'available' | 'taken';
export type StatView = 'season' | 'pergame';

const OWNERSHIP_OPTIONS = [
  { value: 'available', label: 'Available' },
  { value: 'all', label: 'All' },
  { value: 'taken', label: 'Taken' },
] as const;

const STAT_VIEW_OPTIONS = [
  { value: 'season', label: 'Totals' },
  { value: 'pergame', label: 'Per Game' },
] as const;

interface FilterSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ownershipFilter: OwnershipFilter;
  onOwnershipChange: (value: OwnershipFilter) => void;
  pointsTimeFilter: PointsTimeFilter;
  onPointsTimeFilterChange: (value: PointsTimeFilter) => void;
  statView: StatView;
  onStatViewChange: (value: StatView) => void;
}

function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-[10.5px] font-display font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">
      {children}
    </div>
  );
}

export function FilterSheet({
  open,
  onOpenChange,
  ownershipFilter,
  onOwnershipChange,
  pointsTimeFilter,
  onPointsTimeFilterChange,
  statView,
  onStatViewChange,
}: FilterSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="rounded-t-2xl pb-[max(env(safe-area-inset-bottom),1rem)]"
      >
        <SheetHeader className="text-left">
          <SheetTitle className="font-display">Filters</SheetTitle>
        </SheetHeader>

        <div className="space-y-4 mt-3">
          <div>
            <SectionLabel>Availability</SectionLabel>
            <Seg
              value={ownershipFilter}
              options={OWNERSHIP_OPTIONS}
              onChange={(v) => onOwnershipChange(v as OwnershipFilter)}
              ariaLabel="Availability filter"
            />
          </div>

          <div>
            <SectionLabel>Time range</SectionLabel>
            <Seg
              value={pointsTimeFilter}
              options={TIME_FILTER_OPTIONS}
              onChange={(v) => onPointsTimeFilterChange(v as PointsTimeFilter)}
              ariaLabel="Time range filter"
            />
          </div>

          <div>
            <SectionLabel>View</SectionLabel>
            <Seg
              value={statView}
              options={STAT_VIEW_OPTIONS}
              onChange={(v) => onStatViewChange(v as StatView)}
              ariaLabel="Stat view"
            />
          </div>
        </div>

        <Button
          onClick={() => onOpenChange(false)}
          className="w-full mt-5 h-11"
        >
          Done
        </Button>
      </SheetContent>
    </Sheet>
  );
}

export default FilterSheet;
